/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const GraphTrendAlertIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Graph Trend Alert',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m35 33.809-8.659-17.158a1.5 1.5 0 0 0-2.678 0L15 33.809A1.55 1.55 0 0 0 16.407 36h17.186A1.55 1.55 0 0 0 35 33.809ZM24.5 20h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5Zm1.491 12.4h-1.982a.409.409 0 0 1-.409-.409v-1.982a.409.409 0 0 1 .409-.409h1.982a.409.409 0 0 1 .409.409v1.983a.409.409 0 0 1-.409.408ZM33.094 2.061l-7.74 10.815a4.423 4.423 0 0 1 3.423 2.074l5.133-7.334A.5.5 0 0 0 34 7.33V2.352a.5.5 0 0 0-.906-.291ZM19.978 5.374l-5.45 14.992-4.081-4.082a.5.5 0 0 0-.674-.031L2.18 22.579a.5.5 0 0 0-.18.384v4.188a.5.5 0 0 0 .829.377l7.048-6.157 5.343 5.342 4.48-8.871 1.532-2.9a4.425 4.425 0 0 1 3.438-2.067l-3.775-7.554a.5.5 0 0 0-.917.053Z"
    />
  </svg>`;
};
